import { makeStyles, Theme } from "@material-ui/core/styles";
import { BaseCSSProperties } from "@material-ui/core/styles/withStyles";
import GoogleAds from "react-google-ads";
import { useAppState } from "../../common/appState";
import { adminUserId } from "../../common/consts";
import { GOOGLE_ADS_CLIENT, GOOGLE_ADS_SLOT } from "../../common/privateConsts";
import { spaceBetween } from "../../common/util/Array/spaceBetween";

interface Props {
    className?: string;
    style?: BaseCSSProperties;
}

export function GoogleAd({ className, style }: Props) {
    const [user] = useAppState("user");
    const c = useStyles(style ?? {});

    return (
        <aside className={spaceBetween(className, c.aside)}>
            {user?.userId === adminUserId ? (
                <div
                    style={{
                        width: "100%",
                        paddingTop: "100%",
                        backgroundColor: "grey",
                    }}
                />
            ) : (
                <GoogleAds
                    client={GOOGLE_ADS_CLIENT}
                    slot={GOOGLE_ADS_SLOT}
                    className="adsbygoogle"
                    format="auto"
                    style={{ display: "block" }}
                />
            )}
        </aside>
    );
}
const useStyles = makeStyles<Theme, BaseCSSProperties>({
    aside: style => ({ ...style }),
});
